import React, { Component } from 'react';
import './page.css';

import Intro from './intro.js';
import Items from './items.js';
import Text from './text.js';
import Stats from './stats.js';
import Timeline from './timeline.js';

class Page extends Component {
	constructor(props) {
		super(props);
		this.choose = this.choose.bind( this );
		this.returnComponent = this.returnComponent.bind( this );
		
		this.state = {
			"show": null
		}
	}
	
	componentDidMount() {}
	
	componentDidUpdate( prevProps ) {
		if ( this.props.Location && prevProps.Location !== this.props.Location ) {
			this.choose();
		}
		if ( prevProps.IsHome !== this.props.IsHome ) {
			if ( this.props.IsHome ) {
				document.documentElement.classList.add('home');
			} else {
				document.documentElement.classList.remove('home');
			}
		}
	}
	
	choose() {
		if ( this.props.Location ) {
			if ( this.props.Location.indexOf('#/leggi') > -1 ) {
				this.setState( { "show": "page" } );
			} else if ( this.props.Location.indexOf('#/analisi') > -1 ) {
				this.setState( { "show": "stats" } );
			} else if ( this.props.Location.indexOf('#/timeline') > -1 ) {
				this.setState( { "show": "timeline" } );
			} else if ( this.props.Location.indexOf('#/categoria') > -1 ) {
				this.setState( { "show": "items" } );
			} else if ( this.props.Location.indexOf('#/filtra') > -1 ) {
				this.setState( { "show": "items" } );
			} else {
				this.setState( { "show": "home" } );
			}
		}
	}
	
	returnComponent() {
		switch ( this.state.show ) {
  		case "home":
          return <Intro IsHome={this.props.IsHome} BaseUrl={this.props.BaseUrl} SummaryUrl={this.props.SummaryUrl} FetchContent={this.props.FetchContent} ShowLoading={this.props.ShowLoading} Data={this.props.Data} SetTitle={this.props.SetTitle} />;
			case "items":
				return <Items BaseUrl={this.props.BaseUrl} BrowseUrl={this.props.BrowseUrl} FilterUrl={this.props.FilterUrl} StatsUrl={this.props.StatsUrl} PopularityUrl={this.props.PopularityUrl} TopicsUrl={this.props.TopicsUrl} Location={this.props.Location} FetchContent={this.props.FetchContent} ShowLoading={this.props.ShowLoading} AnimationDuration={this.props.AnimationDuration} SetTitle={this.props.SetTitle} VizUrl={this.props.VizUrl} />
			case "stats":
				return <Stats FetchContent={this.props.FetchContent} ShowLoading={this.props.ShowLoading} BaseUrl={this.props.BaseUrl} VizUrl={this.props.VizUrl} AnimationDuration={this.props.AnimationDuration} SetTitle={this.props.SetTitle} />
			case "timeline":
				return <Timeline FetchContent={this.props.FetchContent} ShowLoading={this.props.ShowLoading} BaseUrl={this.props.BaseUrl} VizUrl={this.props.VizUrl} AnimationDuration={this.props.AnimationDuration} TopicsUrl={this.props.TopicsUrl} SetTitle={this.props.SetTitle} />
			case "page":
				return <Text Location={this.props.Location} FetchContent={this.props.FetchContent} ShowLoading={this.props.ShowLoading} AnimationDuration={this.props.AnimationDuration} SetTitle={this.props.SetTitle} />
			default:
				return null;
		}
	}
  
	render() {
		return (
			<section className="main-content">
				{this.returnComponent()}
			</section>
		);
	}
}

export default Page;


// WEBPACK FOOTER //
// ./src/Elezioni/page.js